<template>
    <div class="fastLink">
        <!-- <div class="btn" v-for="(item, index) in classList" :key="index">
            {{item.name}}
        </div> -->
        <div class="btn" @click="turnClass(1)">{{$t('一次性防护服')}}</div>
        <div class="btn" @click="turnClass(2)">{{$t('实验服')}}</div>                   
        <div class="btn" @click="turnPro(3,13)">{{$t('隔离衣')}}</div>                   
        <div class="btn"  @click="turnPro(4,15)">{{$t('一次性防护口罩')}}</div>                   
        <div class="btn" @click="turnClass(5)">{{$t('透气膜头套')}}</div>                   
        <div class="btn" @click="turnPro(6,18)">{{$t('胡须套')}}</div>                   
        <div class="btn" @click="turnPro(7,19)">{{$t('条帽')}}</div>                   
        <div class="btn" @click="turnClass(8)">{{$t('袖套')}}</div>                   
        <div class="btn" @click="turnClass(9)">{{$t('靴套')}}</div>                   
        <div class="btn" @click="turnClass(10)">{{$t('鞋套')}}</div>                   
        <div class="btn" @click="turnPro(11,29)">{{$t('PE塑料手套')}}</div>     
    </div>
</template>
<script>
export default {
    data() {
        return {
            classList:[
                {
                    name:'一次性防护服',
                    src:''
                },
                {
                    name:'实验服',
                    src:''
                },
                {
                    name:'隔离衣',
                    src:''
                },
                {
                    name:'一次性防护口罩',
                    src:''
                },{
                    name:'透气膜头套',
                    src:''
                },{
                    name:'胡须套',
                    src:''
                },{
                    name:'条帽',
                    src:''
                },{
                    name:'袖套',
                    src:''
                },{
                    name:'靴套',
                    src:''
                },{
                    name:'鞋套',
                    src:''
                },
                {
                    name:'PE塑料手套',
                    src:''
                }
            ]
        }
    },
     methods:{
        turnClass(id){
            this.$router.push({
                path:"/productClass_info_class",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:id,
                }
            })
            // this.$router.go(0)
        },
        turnPro(cid,pid){
            this.$router.push({
                path:"/productClass_info",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:cid,
                    productId:pid
                }
            })

            // 
        }
    }
}
</script>
<style lang="less" scoped>
.fastLink{
    width: 65vw;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
    .btn{
        margin: 0 10px;
        color: #6B6B6B;
        cursor: pointer;
        line-height: 3vw;
        &:hover{
            color: #017CA4;
        }
    }

}
</style>
<i18n>
{
  "en": {
       "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
       "一次性防护服":"一次性防护服",
       "实验服":"实验服",
       "隔离衣":"隔离衣",
       "一次性防护口罩":"一次性防护口罩",
       "透气膜头套":"透气膜头套",
       "胡须套":"胡须套",
       "条帽":"条帽",    
       "袖套":"袖套",       
       "靴套":"靴套",       
       "鞋套":"鞋套",
       "PE塑料手套":"PE塑料手套"
    }
}
</i18n>
